import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { QuickBriefService } from './services/quick-brief.service';
import { QbPromotingStep } from './molecules/promoting-step/promoting-step';
import { QbFormatStep } from './molecules/format-step/format-step';
import { QbNetworkStep } from './molecules/network-step/network-step';
import { QbThinkingStep } from './molecules/thinking-step/thinking-step';
import { QbReviewStep } from './molecules/review-step/review-step';
import { QbOutcomeStep } from './molecules/outcome-step/outcome-step';
import { QbSummaryPanel } from './molecules/summary-panel/summary-panel';
import { LoadingOverlayComponent } from '../../atoms/loading-overlay/loading-overlay.component';

@Component({
  selector: 'app-onboarding-quick-brief',
  imports: [
    QbPromotingStep,
    QbFormatStep,
    QbNetworkStep,
    QbThinkingStep,
    QbReviewStep,
    QbOutcomeStep,
    QbSummaryPanel,
    LoadingOverlayComponent,
  ],
  providers: [QuickBriefService],
  templateUrl: './onboarding-quick-brief.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full max-h-full min-h-0 flex-1 flex-col overflow-hidden bg-background text-foreground' },
})
export class OnboardingQuickBrief {
  readonly brief = inject(QuickBriefService);
  private readonly document = inject(DOCUMENT);

  constructor() {
    effect(() => {
      this.brief.step();
      this.document.defaultView?.scrollTo({ top: 0, left: 0 });
    });
  }
}
